<ng-container
    [ngbPopover]="popoverContent"
    [positionTarget]="target"
    [placement]="placement"
    [popoverClass]="popoverClass"
    autoClose="outside"
    (shown)="onPopoverShown()"
    (hidden)="onPopoverHidden()"
    [popperOptions]="popperOptions"
    #popover="ngbPopover"/>

<ng-template #popoverContent>
    <div class="main-div d-flex gap-3">
        <div class="info-div vstack">
            <fdx-surface-tier-icon-button
                [clickable]="false"
                [tier]="tier"
                [feature]="feature"/>
            <div class="h2 mb-0" [innerHTML]="titleHTML"></div>
            <div class="text-secondary" [innerHTML]="descriptionHTML"></div>
            <div class="vstack gap-2 cta-buttons">
                @let planUrl = bigCommerceLinkService.planUrl$ | async;
                @if (planUrl) {
                    <div>
                        <a
                            class="btn"
                            [ngClass]="planButtonClass"
                            [href]="planUrl"
                            target="_blank"
                            rel="noopener"
                            referrerpolicy="no-referrer">
                            <span>{{ plansButtonText }}</span>
                            <fa-icon [icon]="linkIcon" class="fa-icon-right"/>
                        </a>
                    </div>
                }

                @if (featureType?.productsButtonText && productsUrl) {
                    <div>
                        <a
                            class="btn"
                            [ngClass]="productsButtonClass"
                            [href]="productsUrl"
                            target="_blank"
                            rel="noopener"
                            referrerpolicy="no-referrer">
                            <span>{{ featureType.productsButtonText }}</span>
                            <fa-icon [icon]="linkIcon" class="fa-icon-right"/>
                        </a>
                    </div>
                }
            </div>
        </div>
        @if (featureType?.imageURL) {
            <div class="surface-image-container" [ngClass]="backgroundTheme">
                <img [src]="featureType.imageURL" [alt]="featureType.name + ' image'"/>
                <div class="stroke"></div>
            </div>
        }
    </div>
    @if (featureType?.rememberDismissed) {
        <form [formGroup]="rememberForm" class="mt-2">
            <fdx-form-field
                formControlName="dontShowAgain"
                [classes]="{'form-check-inline': true}">
                <fdx-input-checkbox></fdx-input-checkbox>
                <fdx-label>Don't remind me again about this</fdx-label>
            </fdx-form-field>
        </form>
    }
    <div class="close-button-container">
        <button type="button"
            class="btn btn-sm btn-link text-secondary btn-sq"
            aria-label="Close"
            (click)="popover.close()">
            <fa-icon [icon]="closeIcon" class="no-margin"></fa-icon>
        </button>
    </div>
</ng-template>
